import React, { FC } from 'react'
import CarePlanProblem from '../../../../types/CarePlanProblem'
import { formatUTCDate } from '../../../../utils/stringTools'
import './index.css'

interface Props {
  carePlanProblem: CarePlanProblem;
  carePlanProviderSignatureId: number;
}

const CarePlanRow: FC<Props> = ({ carePlanProblem, carePlanProviderSignatureId }: Props) => (
  <div className='care-plan-row'>
    <div className='care-plan-container'>
      <div className='care-plan-text-container'>
        <div className='care-plan-text'>
          <span className='care-plan-name'>{carePlanProblem.problemName}</span>
          {
            carePlanProblem.objective.map((outcome, index) => {
              return (
                <div key={`${carePlanProviderSignatureId}_${outcome.objectiveType}_${index}`}>
                  <span className='care-plan-outcome'>{outcome.objectiveType}: {outcome.objectiveName}</span>
                  {
                    outcome.action.map((action, index) => (
                      <div key={`${carePlanProviderSignatureId}_${action.actionSubType}_${index}`}>
                        <span className='care-plan-action'>Action: {action.actionSubType}: {action.actionName}</span>  
                        <div className='care-plan-action-data'>
                          <div>Priority: <span className='care-plan-bold'>{action.priority}</span></div>
                          <div className='care-plan-action-item'>|</div>
                          <div className='care-plan-action-item'>Start Date: <span className='care-plan-bold'>{( action.effectiveDate && formatUTCDate(action.effectiveDate) ) || ''}</span></div>
                          <div className='care-plan-action-item'>|</div>
                          <div className='care-plan-action-item'>Closed Date: <span className='care-plan-bold'>{( action.closeDate && formatUTCDate(action.closeDate) ) || ''}</span></div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  </div>
)

export default CarePlanRow
